export default "__VITE_ASSET__CvXq33Sb__"